import { Title } from "@angular/platform-browser";
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
declare let Plotly: any;
import { optionsAvgTRes, optionsErrorCount, optionsThroughput, optionsHitsPSec } from "@app/_constants";
import { optionsUsers } from "@app/_constants/perflab-results-option-users";
import { environment } from "@environments/environment";
import { ToastrService } from "ngx-toastr";
import { interval, Subscription } from "rxjs";
import { Role } from "@app/_models/role";
import { ChartConfigService } from "@app/_services";
import * as moment from 'moment-timezone';
import { PerformanceService } from "@app/performance/performance.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { CustomTimeParser } from "@app/_shared/schedule/schedule.component";
import { CustomAdapter, CustomDateParserFormatter } from "@app/execution-history/testsuite/testsuite.component";
import { ModalDismissReasons, NgbDateAdapter, NgbDateParserFormatter, NgbModal, NgbTimeAdapter } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-new-performance-result-summary",
  templateUrl: "./new-performance-result-summary.component.html",
  styleUrls: ["./new-performance-result-summary.component.less"],
  providers: [
    ChartConfigService,
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbTimeAdapter, useClass: CustomTimeParser },
    DatePipe,
  ],
})
export class NewPerformanceResultSummaryComponent implements OnInit {
  readonly ADMIN = Role[0].role;
  readonly SUPER_ADMIN = Role[4].role;
  readonly INTERVAL_TIME = 15;

  @Input() startTimeForm: FormGroup;
  @Input() endTimeForm: FormGroup;
  @Input() showNewGraphSection: any;
  @Input() isAutoRefresh = true;
  @Input() autoRefreshInterval = this.INTERVAL_TIME;
  @Input() set testcaseTopLevelDataInput(value: any) {
    if(value !== undefined) {
      this.testcaseTopLevelData = value;
      this.getTestcaseTopDetails(value);
      this.executedTaskId = value.response.performanceRequest.id;
    }
  }

  @ViewChild("dataVUsers") dataVUsersSection!: ElementRef;
  @ViewChild("dataAvgTRes") dataAvgTResSection!: ElementRef;
  @ViewChild("dataHitsPSec") dataHitsPSecSection!: ElementRef;
  @ViewChild("dataErrorCount") dataErrorCountSection!: ElementRef;
  @ViewChild("dataThroughput") dataThroughputSection!: ElementRef;
  @Output() showLoadingDivEmitter = new EventEmitter<boolean>();

  executedTaskId: any;
  testCompleted = false;
  @Input() perResults: any;
  intervalTimer: Subscription;
  queueRes = [];
  abortTriggered: boolean;

  dataUsers = [];
  datasetOverride: any;
  labelsAvgTRes = [];
  dataHitsPSec: Array<any> = [{}];
  dataVUsers: Array<any> = [{}];
  dataThroughput: Array<any> = [{}];
  dataAvgTRes: Array<any> = [{}];
  dataErrorCount: Array<any> = [{}];

  dataHitsPSecNew: Array<any> = [{}];
  dataVUsersNew: Array<any> = [{}];
  dataThroughputNew: Array<any> = [{}];
  dataAvgTResNew: Array<any> = [{}];
  dataErrorCountNew: Array<any> = [{}];

  icon = {
    'width': 575,
    'path': 'M448 344v112a23.9 23.9 0 0 1 -24 24H312c-21.4 0-32.1-25.9-17-41l36.2-36.2L224 295.6 116.8 402.9 153 439c15.1 15.1 4.4 41-17 41H24a23.9 23.9 0 0 1 -24-24V344c0-21.4 25.9-32.1 41-17l36.2 36.2L184.5 256 77.2 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.9 23.9 0 0 1 24-24h112c21.4 0 32.1 25.9 17 41l-36.2 36.2L224 216.4l107.2-107.3L295 73c-15.1-15.1-4.4-41 17-41h112a23.9 23.9 0 0 1 24 24v112c0 21.4-25.9 32.1-41 17l-36.2-36.2L263.5 256l107.3 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z',
    'ascent': 400,
    'descent': 100
  };

  plotlyGraphConfig = {
    displaylogo: false,
    scrollZoom: false,
    toImageButtonOptions: {
      format: 'png',
      filename: 'custom_image',
    },
  }

  buttonConfig = {
    modeBarButtonsToRemove: ["lasso2d", "select2d", 'autoscale'],
    modeBarButtonsToAdd: [{
      name: 'FullScreen ',
      icon: this.icon,
      click: (data: any) => {
        if(data.id === "plot-dataVUsers") {
          this.graphType[0].fullScreen = !this.graphType[0].fullScreen;
        } else if(data.id === "plot-dataAvgTRes") {
          this.graphType[1].fullScreen = !this.graphType[1].fullScreen;
        } else if(data.id === "plot-dataHitsPSec") {
          this.graphType[2].fullScreen = !this.graphType[2].fullScreen;
        } else if(data.id === "plot-dataErrorCount") {
          this.graphType[3].fullScreen = !this.graphType[3].fullScreen;
        } else if(data.id === "plot-dataThroughput") {
          this.graphType[4].fullScreen = !this.graphType[4].fullScreen;
        }
        this.regenerateAllGraph();
      }
    }]
  }

  series = [];
  labels: string[] = [];
  lineChartType = "line";
  colors: any = ["green"];
  length: number;
  showFilter = false;
  showTableMetric = true;
  showResultGraph = true;
  allResultGraphsNull = false;
  threadGroupFilterList = [];
  endpointFilterList = [];

  machineStats = [];
  isAuthorized = false;
  authorizationMsg = "";
  created_date: any;
  currentPSTTime: any;
  diff: any;
  direction: string = "asc";
  sortDirection = true;
  loadTestDataDetails = true;
  selectedGraphTypes: number[] = [0, 1, 2, 3];
  uniqueThreadGroupArray: any = [];
  newGraphData: any = [];
  selectedEndpoints: any = [];
  selectedThreadGroup: any = [];
  testcaseTopLevelData: any;
  fullScreen: any = false;

  startDate: any;
  endDate: any;
  startTime: any;
  endTime: any;
  minDate: any;
  maxDate: any;
  startDateTime: any = null;
  endDateTime: any = null;
  filterDurationType: any = true;
  finalSelectedStartTime: any;
  finalSelectedEndTime: any;
  finalDisplayedStartTime: any;
  finalDisplayedEndTime: any;
  closeResult: string;

  graphType = [
    { name: "vUsers", id: 0, show: true, fullScreen: false },
    { name: "Average Response Time", id: 1, show: true, fullScreen: false },
    { name: "Hits Achieved", id: 2, show: true, fullScreen: false },
    { name: "Error Count", id: 3, show: true, fullScreen: false },
    { name: "Throughput(Kbps)", id: 4, show: false, fullScreen: false },
  ];
  emailFormArray: Array<any> = ["Hits Achieved", "Average Response Time"];
  detailReportTable: boolean = false;

  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private perfService: PerformanceService,
    private router: Router,
    private toastr: ToastrService,
    private chart: ChartConfigService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    public modalService: NgbModal
  ) {}

  ngOnInit() {
    this.setForm();
    this.selectFirstTwo();
  }

  selectFirstTwo() {
    this.graphType.slice(0, 2).forEach((category) => {
      if (!this.emailFormArray.includes(category.name)) {
        this.onChange(category.name, true);
      }
    });
  }

  onChange(email: string, isChecked: boolean) {
    if (isChecked) {
      this.emailFormArray.push(email);
    } else {
      let index = this.emailFormArray.indexOf(email);
      if (index >= 0) {
        this.emailFormArray.splice(index, 1);
      }
    }
  }

  resultTestCase() {
    if (this.executedTaskId === "") {
      this.toastr.info("Please execute a test or select from queue");
      this.router.navigateByUrl("/performance/loadTesting");
      return false;
    }
    this.getTestcaseTopDetails(this.executedTaskId);
  }

  getTestcaseTopDetails(data?: any) {
    if (data.code === 200) {
      this.testcaseTopLevelData = data.response;
      this.setThreadGroupFilterList(data.response.threadGroups);
      this.setEndpointFilterList(data.response.endPoints);
      const respData = data.response;
      const date1 = data.response.performanceRequest.startTime;
      const splitDate1 = date1.split(" ")[0];
      const splitTime1 = date1.split(" ")[1];
      this.startDate = splitDate1;
      this.startTime = splitTime1;
      this.setMindate(splitDate1);
      const date2 = data.response.performanceRequest.endTime;
      const splitDate2 = date2.split(" ")[0];
      const splitTime2 = date2.split(" ")[1];
      this.endDate = splitDate2;
      this.endTime = splitTime2;
      this.setMaxDate(splitDate2);
      this.isAuthorized = true;
      this.testCompleted = respData.executionCompleted;
      this.perResults.testcaseExecSumm = respData;

      this.perResults.testcaseExecSumm.hitsPerSec = respData.noOfHits / respData.elapsedTime || 0;

      if (this.perResults.testcaseExecSumm.name) {
        this.titleService.setTitle("Perf-Result | " + this.perResults.testcaseExecSumm.name);
      }
      this.showNewGraph(this.showNewGraphSection);
      const todayDate = moment();
      this.currentPSTTime = todayDate.tz("America/Los_Angeles").format("YYYY-MM-DD HH:mm:ss");
      this.created_date = this.perResults.testcaseExecSumm.performanceRequest.startTime;
      this.diff = this.getDataDiff(new Date(this.created_date), new Date(this.currentPSTTime));
    } else if (data.code == 204) {
      this.isAuthorized = false;
      this.authorizationMsg = data.message;
    }
  }

  resetTime() {
    const date1 = this.testcaseTopLevelData.performanceRequest.startTime;
    const splitDate1 = date1.split(" ")[0];
    const splitTime1 = date1.split(" ")[1];
    this.startDate = splitDate1;
    this.startTime = splitTime1;
    this.setMindate(splitDate1);
    const date2 = this.testcaseTopLevelData.performanceRequest.endTime;
    const splitDate2 = date2.split(" ")[0];
    const splitTime2 = date2.split(" ")[1];
    this.endDate = splitDate2;
    this.endTime = splitTime2;
    this.setMaxDate(splitDate2);
  }

  setThreadGroupFilterList(threadGroupList: any) {
    if(this.showNewGraphSection) {
      this.threadGroupFilterList = Object.entries(threadGroupList.csv).map(([key, value]) => ({ key, value }));
    } else {
      this.threadGroupFilterList = Object.entries(threadGroupList.db).map(([key, value]) => ({ key, value }));
    }
  }

  setEndpointFilterList(endpointList: any) {
    if(this.showNewGraphSection) {
      this.endpointFilterList = Object.entries(endpointList.csv).map(([key, value]) => ({ key, value }));
    } else {
      this.endpointFilterList = Object.entries(endpointList.db).map(([key, value]) => ({ key, value }));
    }
    console.log(this.endpointFilterList);
  }

  setMindate(startDate?) {
    const custFormat = new CustomDateParserFormatter();
    const date = startDate || new Date();
    this.minDate = custFormat.parse(this.datePipe.transform(date, "yyyy-MM-dd"));
  }

  setMaxDate(endDate?) {
    const custFormat = new CustomDateParserFormatter();
    const date = endDate || new Date();
    this.maxDate = custFormat.parse(this.datePipe.transform(date, "yyyy-MM-dd"));
  }

  getDataDiff(startDate, endDate) {
    const diff = endDate.getTime() - startDate.getTime();
    const days = Math.floor(diff / (60 * 60 * 24 * 1000));
    const hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
    const minutes = Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);
    const seconds = Math.floor(diff / 1000) - (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
    return { day: days, hour: hours, minute: minutes, second: seconds };
  }

  sortByColumn(columnName: string) {
    this.direction = this.sortDirection ? "desc" : "asc";
    // let direction = 'desc';
    let sortedArray;
    if (columnName === "name") {
      sortedArray = (this.queueRes || []).sort((a, b) => {
        let val1 = a[columnName].toLowerCase();
        let val2 = b[columnName].toLowerCase();
        if (val1 > val2) {
          return this.direction === "asc" ? 1 : -1;
        }
        if (val1 < val2) {
          return this.direction === "asc" ? -1 : 1;
        }
        return 0;
      });
    } else {
      sortedArray = (this.queueRes || []).sort((a, b) => {
        if (a[columnName] > b[columnName]) {
          return this.direction === "asc" ? 1 : -1;
        }
        if (a[columnName] < b[columnName]) {
          return this.direction === "asc" ? -1 : 1;
        }
        return 0;
      });
    }
    this.sortDirection = !this.sortDirection;
    // return sortedArray;
    this.queueRes = sortedArray;
  }

  secondsToDhms(seconds) {
    seconds = parseInt(seconds, 10);
    var days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    var hrs = Math.floor(seconds / 3600);
    seconds -= hrs * 3600;
    var mnts = Math.floor(seconds / 60);
    seconds -= mnts * 60;
    var dDisplay = days > 0 ? days + (days == 1 ? "D  " : "D  ") : "";
    var hDisplay = hrs > 0 ? (hrs < 10 ? "0" : "") + hrs : "00";
    var mDisplay = mnts > 0 ? (mnts < 10 ? ":0" : ":") + mnts : ":00";
    var sDisplay = seconds > 0 ? (seconds < 10 ? ":0" : ":") + seconds : ":00";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }

  showNewGraph(event: any) {
    if (event) {
      this.showNewGraphSection = event;
      this.setThreadGroupFilterList(this.testcaseTopLevelData.threadGroups);
      this.setEndpointFilterList(this.testcaseTopLevelData.endPoints);
      this.getNewGraphDetails();
    } else {
      this.showNewGraphSection = event;
      this.setThreadGroupFilterList(this.testcaseTopLevelData.threadGroups);
      this.setEndpointFilterList(this.testcaseTopLevelData.endPoints);
      this.getNewGraphDetails();
    }
  }

  getNewGraphDetails() {
    if (this.validateFilter()) {
      let params = {
        threadGroups: this.selectedThreadGroup.length > 0 ? this.selectedThreadGroup : null,
        endpoints: this.selectedEndpoints.length > 0 ? this.selectedEndpoints : null,
        startDateTime: this.startDateTime,
        endDateTime: this.endDateTime,
        relativeDuration: !this.filterDurationType,
        csvData: this.showNewGraphSection,
      };
      this.perfService.getGraphDetails(params, this.testcaseTopLevelData.performanceRequest.id).subscribe((data) => {
        if(data.code === 200) {
        this.queueRes = data.response.map((obj) => {
          obj.passedHits = obj.noOfHits - obj.errorCount;
          return obj;
        });
        this.uniqueThreadGroupArray = data.response.reduce((acc, obj) => {
          if (!acc.some((o) => o.threadGroupSequence === obj.threadGroupSequence)) {
            if (obj.resultGraphs !== null) {
              acc.push(obj);
            }
          }
          return acc;
        }, []);
        this.allResultGraphsNull = data.response.every(item => item.resultGraphs === null);
        if(this.testcaseTopLevelData.status === "SCHEDULED") {
          this.showResultGraph = false;
        } else if (this.allResultGraphsNull) {
          this.showResultGraph = false;
          return;
        } else {
          this.plotDataVUsersGraph(this.uniqueThreadGroupArray);
          this.plotAverageResponseTimeGraph(data);
          this.dataHitsPerSecGraph(data);
          this.dataErrorCountGraph(data);
          this.dataThroughputGraph(data);
          this.showResultGraph = true;
          this.showLoadingDivEmitter.emit(false);
        }
      } else if(data.code === 204) {
        this.toastr.error(data.message);
      }
      });
    }
  }

  regenerateAllGraph() {
    const tempObject = {
      response: this.queueRes
    }
    this.plotDataVUsersGraph(this.uniqueThreadGroupArray);
    this.plotAverageResponseTimeGraph(tempObject);
    this.dataHitsPerSecGraph(tempObject);
    this.dataErrorCountGraph(tempObject);
    this.dataThroughputGraph(tempObject);
  }

  plotAverageResponseTimeGraph(data) {
    let avgResponseTimeGraphData = [];
    let avgResponseData: any;
    let tempConfig = JSON.parse(JSON.stringify(this.plotlyGraphConfig));
    for (const index in data.response) {
      if(data.response[index].resultGraphs !== null) {
        avgResponseData = data.response[index].resultGraphs[3];
        avgResponseTimeGraphData.push(this.makeTraceData(avgResponseData, data.response[index].name));
      }
    }
    tempConfig.toImageButtonOptions.filename = "Avg.Response Time";
    if(avgResponseData !== undefined && avgResponseData !== null) {
      setTimeout(() => {
        Plotly.newPlot("plot-dataAvgTRes", avgResponseTimeGraphData, this.makeLayoutData(avgResponseData), {...tempConfig, ...this.buttonConfig}).then(() => {
          this.dataAvgTResSection.nativeElement.on("plotly_click", (eventData: any) => {
            this.setClickEventListener(avgResponseTimeGraphData, eventData);
          });
        });
      }, 200);
    }
  }

  plotDataVUsersGraph(data) {
    let dataVUsersGraphData = [];
    let dataVUsereData: any;
    let tempConfig = JSON.parse(JSON.stringify(this.plotlyGraphConfig));
    for (const index in data) {
      if(data[index].resultGraphs !== null) {
        dataVUsereData = data[index].resultGraphs[0];
        dataVUsersGraphData.push(this.makeTraceData(dataVUsereData, data[index].name));
      }
    }
    tempConfig.toImageButtonOptions.filename = "Running VUser";
    if(dataVUsereData !== undefined && dataVUsereData !== null) {
      setTimeout(() => {
        Plotly.newPlot("plot-dataVUsers", dataVUsersGraphData, this.makeLayoutData(dataVUsereData), {...tempConfig, ...this.buttonConfig}).then(() => {
          this.dataVUsersSection.nativeElement.on("plotly_click", (eventData: any) => {
            this.setClickEventListener(dataVUsersGraphData, eventData);
          });
        });
      }, 200);
    }
  }

  dataHitsPerSecGraph(data) {
    let dataHitsPerSecGraphData = [];
    let dataHitsPerSecData: any;
    let tempConfig = JSON.parse(JSON.stringify(this.plotlyGraphConfig));
    for (const index in data.response) {
      if(data.response[index].resultGraphs !== null) {
        dataHitsPerSecData = data.response[index].resultGraphs[1];
        dataHitsPerSecGraphData.push(this.makeTraceData(dataHitsPerSecData, data.response[index].name));
      }
    }
    tempConfig.toImageButtonOptions.filename = "Total Hits";
    if(dataHitsPerSecData !== undefined && dataHitsPerSecData !== null) {
      setTimeout(() => {
        Plotly.newPlot("plot-dataHitsPSec", dataHitsPerSecGraphData, this.makeLayoutData(dataHitsPerSecData), {...tempConfig, ...this.buttonConfig}).then(() => {
          this.dataHitsPSecSection.nativeElement.on("plotly_click", (eventData: any) => {
            this.setClickEventListener(dataHitsPerSecGraphData, eventData);
          });
        });
      }, 200);
    }
  }

  dataThroughputGraph(data) {
    let dataThroughputGraphData = [];
    let dataThroughputData: any;
    let tempConfig = JSON.parse(JSON.stringify(this.plotlyGraphConfig));
    for (const index in data.response) {
      if(data.response[index].resultGraphs !== null) {
        dataThroughputData = data.response[index].resultGraphs[2];
        dataThroughputGraphData.push(this.makeTraceData(dataThroughputData, data.response[index].name));
      }
    }
    tempConfig.toImageButtonOptions.filename = "Throughput";
    if(dataThroughputData !== undefined && dataThroughputData !== null) {
      setTimeout(() => {
        Plotly.newPlot("plot-dataThroughput", dataThroughputGraphData, this.makeLayoutData(dataThroughputData), {...tempConfig, ...this.buttonConfig}).then(() => {
          this.dataThroughputSection.nativeElement.on("plotly_click", (eventData: any) => {
            this.setClickEventListener(dataThroughputGraphData, eventData);
          });
        });
      }, 200);
    }
  }

  dataErrorCountGraph(data) {
    let dataErrorCountGraphData = [];
    let dataErrorCountData: any;
    let tempConfig = JSON.parse(JSON.stringify(this.plotlyGraphConfig));
    for (const index in data.response) {
      if(data.response[index].resultGraphs !== null) {
        dataErrorCountData = data.response[index].resultGraphs[4];
        dataErrorCountGraphData.push(this.makeTraceData(dataErrorCountData, data.response[index].name));
      }
    }
    tempConfig.toImageButtonOptions.filename = "Error";
    if(dataErrorCountData !== undefined && dataErrorCountData !== null) {
      setTimeout(() => {
        Plotly.newPlot("plot-dataErrorCount", dataErrorCountGraphData, this.makeLayoutData(dataErrorCountData), {...tempConfig, ...this.buttonConfig}).then(() => {
          this.dataErrorCountSection.nativeElement.on("plotly_click", (eventData: any) => {
            this.setClickEventListener(dataErrorCountGraphData, eventData);
          });
        });
      }, 200);
    }
  }

  setClickEventListener(data, eventData) {
    var selectedIndex: any;
    for(let i=0; i< data.length; i++) {
      selectedIndex = data[i].x.indexOf(eventData.points[0].x);
      if(selectedIndex >= 0) {
        break;
      }
    }
    const updatedData = {
      selectedpoints: [[selectedIndex]],
      selected: {
        marker: {
          color: "#000000",
          size: 8
        },
      },
    };
    Plotly.update("plot-dataVUsers", updatedData);
    Plotly.update("plot-dataAvgTRes", updatedData);
    Plotly.update("plot-dataHitsPSec", updatedData);
    Plotly.update("plot-dataErrorCount", updatedData);
    Plotly.update("plot-dataThroughput", updatedData);
  }

  makeTraceData(data, name) {
    const trace1 = {
      x: data.xValues,
      y: data.yValues,
      name: name,
      hoverinfo: "name + y",
      hoverlabel: {namelength: -1},
      mode: "lines+markers",
      type: "scatter",
    };
    return trace1;
  }

  makeLayoutData(data) {
    let layout = {
      title: {
        text: data.name,
      },
      hovermode: 'x unified',
      showlegend: false,
      xaxis: {
        title: {
          text: data.x_lable,
        },
        rangemode: "nonnegative",
        showline: true
      },
      yaxis: {
        title: {
          text: data.y_lable,
        },
        rangemode: "nonnegative"
      },
    };
    return layout;
  }

  allFullScreen(fullScreen: any) {
    this.fullScreen = !fullScreen;
    for(let i=0; i< this.graphType.length; i++) {
      this.graphType[i].fullScreen = this.fullScreen;
    }
    this.regenerateAllGraph();
  }

  validateFilter() {
    if (this.startDateTime !== null) {
      if (this.endDateTime === null) {
        this.toastr.warning("Please Enter End Date and Time");
        return false;
      }
    }
    if (this.endDateTime !== null) {
      if (this.startDateTime === null) {
        this.toastr.warning("Please Enter Start Date and Time");
        return false;
      }
    }
    if (!this.filterDurationType) {
      if (this.startDateTime > this.endDateTime) {
        this.toastr.warning("Start time should be less than end time");
        return false;
      }
      if (this.perResults.testcaseExecSumm?.elapsedTime < this.endDateTime) {
        this.toastr.warning("End time should not be greater than the elapsed time");
        return false;
      }
      if (this.startDateTime < 0) {
        this.toastr.warning("Start time should be greater than 0");
        return false;
      }
    } else {
      const executionStartDateTime = new Date(this.perResults.testcaseExecSumm.performanceRequest.startTime);
      const executionEndDateTime = new Date(this.perResults.testcaseExecSumm.performanceRequest.endTime);
      const filterStartDateTime = new Date(this.startDateTime);
      const filterEndDateTime = new Date(this.endDateTime);
      if (filterStartDateTime > filterEndDateTime) {
        this.toastr.warning("The end time must not be before the start time.");
        return false;
      }
      if (this.startDateTime !== null && this.endDateTime !== null && filterStartDateTime < executionStartDateTime) {
        this.toastr.warning("The start time must be equal to or later than the actual start time.");
        return false;
      }
      if (this.startDateTime !== null && this.endDateTime !== null && filterEndDateTime > executionEndDateTime) {
        this.toastr.warning("The end time must be equal to or earlier than the actual end time.");
        return false;
      }
    }
    return true;
  }

  showSelectedGraphs(event: any) {
    if (this.selectedGraphTypes.length > 0) {
      for (let i = 0; i < this.graphType.length; i++) {
        if (this.selectedGraphTypes.includes(this.graphType[i].id)) {
          this.graphType[i].show = true;
        } else {
          this.graphType[i].show = false;
        }
      }
    } else {
      for (let i = 0; i < this.graphType.length; i++) {
        if (this.graphType[i].id === 4) {
          this.graphType[i].show = false;
        } else {
          this.graphType[i].show = true;
        }
      }
      this.selectedGraphTypes = [0, 1, 2, 3];
    }
    this.regenerateAllGraph();
  }

  setForm() {
    this.startTimeForm = this.formBuilder.group({
      day: [0],
      hour: [0],
      minutes: [0],
      second: [0],
    });

    this.endTimeForm = this.formBuilder.group({
      day: [0],
      hour: [0],
      minutes: [0],
      second: [0],
    });
  }

  setStartDateTime() {
    this.startDateTime = this.startDate + " " + this.startTime;
  }

  setEndDateTime() {
    this.endDateTime = this.endDate + " " + this.endTime;
  }

  setStartTime(data: any) {
    let totalDayToSeconds = data.day === null ? 0 : data.day * 24 * 60 * 60;
    let totalMinutesToSeconds = data.minutes === null ? 0 : data.minutes * 60;
    let totalHourToSeconds = data.hour === null ? 0 : data.hour * 60 * 60;
    this.startDateTime = totalDayToSeconds + totalHourToSeconds + totalMinutesToSeconds + (data.second === null ? 0 : parseInt(data.second));
    this.finalDisplayedStartTime = (data.day === null ? 0 : data.day) + "D :" + (data.hour === null ? 0 : data.hour) + "H : " + (data.minutes === null ? 0 : data.minutes) + "M : " + (data.second === null ? 0 : data.second) + "S";
  }

  setEndTime(data: any) {
    let totalDayToSeconds = data.day === null ? 0 : data.day * 24 * 60 * 60;
    let totalMinutesToSeconds = data.minutes === null ? 0 : data.minutes * 60;
    let totalHourToSeconds = data.hour === null ? 0 : data.hour * 60 * 60;
    this.endDateTime = totalDayToSeconds + totalHourToSeconds + totalMinutesToSeconds + (data.second === null ? 0 : parseInt(data.second));
    this.finalDisplayedEndTime = (data.day === null ? 0 : data.day) + "D :" + (data.hour === null ? 0 : data.hour) + "H : " + (data.minutes === null ? 0 : data.minutes) + "M : " + (data.second === null ? 0 : data.second) + "S";
  }

  resetFilter() {
    this.startDateTime = null;
    this.endDateTime = null;
    this.finalDisplayedStartTime = null;
    this.finalDisplayedEndTime = null;
    this.setForm();
    this.resetTime();
  }

  openDateTimePopup(modal) {
    this.open(modal, "lg");
  }

  open(content: any, sizeOfModal: any): void {
    this.modalService.open(content, {
      windowClass: "modal-holder",
      backdrop: "static",
      size: sizeOfModal,
      ariaLabelledBy: "modal-basic-title",
    }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  saveFilter() {
    if (!this.filterDurationType) {
      this.setStartTime(this.startTimeForm.value);
      this.setEndTime(this.endTimeForm.value);
    } else {
      this.setStartDateTime();
      this.setEndDateTime();
    }
    if (this.validateFilter()) {
      this.modalService.dismissAll();
    }
  }

  clearAllFilters() {
    this.selectedEndpoints = [];
    this.selectedThreadGroup = [];
    this.startDateTime = null;
    this.finalDisplayedStartTime = null;
    this.endDateTime = null;
    this.finalDisplayedEndTime = null;
    this.setForm();
    this.resetTime();
  }

  showDetailReport(isChecked: boolean) {
    this.detailReportTable = isChecked;
  }

  showFullScreen(fullScreen: any) {
    if(fullScreen) {
      return 'col-12'
    } else {
      return 'col-6'
    }
  }

  ngOnDestroy(): void {
    if (this.intervalTimer) this.intervalTimer.unsubscribe();
  }
}
